const API_URL = process.env.NODE_ENV === 'production'
    ? '/api'
    : 'http://localhost:3045/api';

const GOOGLE_CLIENT_ID = '370202386138-hq9ak1lemnfnosrdtn446tkrcc1klgsk.apps.googleusercontent.com';

enum JobStage {
    START = 'start',
    ERID_REPORT = 'eridReport',
    FORM_DOC_GOOGLE = 'formDocGoogle',
    FORM_ADDITIONAL = 'formAdditional',
    FORM_CREATIVE = 'formCreative',
    FORM_INVOICE = 'InvoiceForm'
}

enum DocType {
    ADDITIONAL = 'additional',
    INVOICE = 'invoice'
}

const KKTU_OPTIONS = [
    { value: '12.2.2', label: '12.2.2 - Лекарственное средство' },
    { value: '12.2.1', label: '12.2.1 - БАД' }
]

const LIMIT_FILE_SIZE_MB = 50
const LIMIT_FILE_SIZE = LIMIT_FILE_SIZE_MB * 1024 * 1024

export {API_URL, GOOGLE_CLIENT_ID, JobStage, DocType, KKTU_OPTIONS, LIMIT_FILE_SIZE, LIMIT_FILE_SIZE_MB};
